// TODO Implement
import { toastr } from 'react-redux-toastr';
import * as systemConstants from '../constants/systemConstants';
import { clearPermissions } from './authz';
export function authHeader() {

}

export function currentUser() {
  return JSON.parse(localStorage.getItem('userAuth'));
}

export function accessToken() {
  return localStorage.getItem('accessToken');
}

export function isAuth() {
  return localStorage.getItem('isAuth');
}

export function login(token = {}) {
  localStorage.setItem('userAuth', JSON.stringify(token));
  localStorage.setItem('accessToken', token.token);
  localStorage.setItem('isAuth', true);
  toastr.success(systemConstants.MESSAGE_PREFIX, 'Welcome to LLQ HRMS!');
  return true;
}
export function logout() {
  // localStorage.clear() không đụng tới cache quyền đang giữ trong bộ nhớ của authz.js,
  // nên phải xoá tay: tránh user đăng nhập sau thấy lại quyền của user trước khi chưa F5.
  clearPermissions();
  localStorage.clear();
  return true;
}

export function setRemember(user = {}) {
  localStorage.setItem('userRemember', JSON.stringify(user));
  return true;
}

export function removeRemember() {
  localStorage.removeItem('userRemember');
  return true;
}

export function removeIsAuth() {
  localStorage.removeItem('isAuth');
}
